import React, { Component } from 'react';
import axios from 'axios';
import Input from '../../components/Input';
import Button from '../../components/Button';
import styled from 'styled-components';
import BackgroundLogin from '../../assets/images/backgroundLogin.png';
import BackgroundVideo from '../../assets/video/map_login.mp4';
import Icon from '../../components/Icon';
import history from '../../history';
import getEnvVariable from '../../utils/env';

const AuthContainer = styled.div`
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background-image: url(${BackgroundLogin});
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    pointer-events: none;
    position: absolute;
  }

  .loginContentContainer {
    width: 15%;
    z-index: 2;
    min-width: 350px;
    min-height: 480px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 10px solid white;
  }

  .resetInputContainer {
    margin-top: 10px;
  }

  .wrapperLoginContent {
    width: calc(100% - 100px);
    height: calc(100% - 80px);
    padding: 40px 50px;
    border-radius: 4px;
    background-color: white;
    border: 1px solid #f0f0f0;
  }

  .loginSeparator {
    height: 1px;
    background-color: #e8eaeb;
    margin-top: 27px;
    margin-bottom: 30px;
    width: 100%;
  }

  .loginTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 30px;
    color: ${(props) => props.theme.colors.dark};
    margin-bottom: 20px;
  }

  .loginInputContainer {
    width: 100%;
    margin-bottom: 16px;
    position: relative;
  }

  .forgotPasswordText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    margin-left: auto;
    color: #02384a;
    opacity: 0.3;
    letter-spacing: -0.6px;
    text-decoration: underline;
  }

  .forgotPasswordText:hover {
    cursor: pointer;
  }

  .requirements {
    display: block;
    margin-top: 5px;
    font-size: 10px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: ${(props) => props.theme.colors.dark};
  }

  .requirements > .title {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .loginSubmitContainer {
    width: 100%;
    margin-top: 10px;
  }

  .loginSubmitContainer > div {
    width: 100%;
  }

  .hidePasswordIcon {
    position: absolute;
    right: 21px;
    top: 38px;
    color: #e8eaeb;
  }
  .hidePasswordIcon:hover {
    cursor: pointer;
  }

  .loginLogoContainer {
    width: 66%;
  }

  .congratulation {
    text-align: center;
    color: #00a699;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    height: 20px;
    margin-top: 20px;
    font-size: 12px;
  }

  .errorPassword {
    text-align: center;
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    height: 20px;
    margin-top: 20px;
    font-size: 12px;
  }
`;

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uid: '',
      token: '',
      password: '',
      passwordDouble: '',
      error: '',
      validation: ''
    };
  }

  componentDidMount() {
    this.setState({
      token: this.props.match.params.token,
      uid: this.props.match.params.uid
    });
  }

  showValidation(validation) {
    this.setState({ validation: validation, error: false });
  }

  showError(error) {
    this.setState({ error: error });
  }

  async sendNewPassword() {
    const { password, passwordDouble, uid, token } = this.state;
    const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
    if (this.verifyAuthenticity(password)) {
      if (password === passwordDouble) {
        await axios
          .post(`${reactAppApiUrl}/rest-auth/password/reset/confirm/`, {
            uid: uid,
            token: token,
            new_password1: password,
            new_password2: passwordDouble
          })
          .then((response) => {
            this.showValidation('Votre mot de passe a bien été modifié');
          })
          .catch((error) => {
            this.setState({ validation: true });
            this.showError(
              'Votre demande a expiré, veuillez refaire une demande de mot de passe oublié'
            );
          });
      } else {
        this.showError('Les deux mots de passe doivent être identique');
      }
    }
  }

  verifyAuthenticity(password) {
    const authenticity =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

    if (authenticity.test(password)) {
      this.setState({ password: password });
      return true;
    } else {
      this.showError(
        'Le mot de passe ne répond pas aux critères de validation'
      );
      return false;
    }
  }

  renderMessage() {
    const { error, validation } = this.state;

    if (error) {
      return <div className="errorPassword">{error}</div>;
    } else if (validation) {
      return <div className="congratulation">{validation}</div>;
    }
  }

  render() {
    const { password, passwordDouble, error, validation } = this.state;
    const renderMessage = this.renderMessage();
    return (
      <AuthContainer>
        <video
          autoPlay="autoplay"
          loop
          playsInline
          muted
          allowFullScreen
          src={BackgroundVideo}
          type="video/mp4"
          className="video"
        />
        <div className="loginContentContainer">
          <div className="wrapperLoginContent">
            <div className="loginLogoContainer">
              <Icon icon="logoBig" />
            </div>
            <div className="loginSeparator" />
            <h1 className="loginTitle">Définir un nouveau mot de passe</h1>
            <div className="loginInputContainer">
              <Input
                label="Nouveau mot de passe"
                placeholder="exemple: “&Z88ee2009“"
                value={password}
                disabled={validation}
                onChange={(password) => this.setState({ password: password })}
              />
              <span className="requirements">
                8 caractères minimum <br /> Au moins 1 lettre, 1 chiffre, 1
                majuscule, 1 minuscule et 1 symbole.
              </span>
            </div>
            <div className="loginInputContainer">
              <Input
                label="Répéter le mot de passe"
                value={passwordDouble}
                disabled={validation}
                placeholder="Doit être identique au précédent"
                onChange={(passwordDouble) =>
                  this.setState({ passwordDouble: passwordDouble })
                }
              />
            </div>

            {renderMessage}

            {!validation ? (
              <div className="loginSubmitContainer">
                <Button
                  label="Enregistrer"
                  text-transform="normal"
                  onClick={() => this.sendNewPassword()}
                />
              </div>
            ) : (
              <div className="loginSubmitContainer">
                <Button
                  label="Retour à l'accueil"
                  text-transform="normal"
                  onClick={() => history.push('/')}
                />
              </div>
            )}
          </div>
        </div>
      </AuthContainer>
    );
  }
}

export default ResetPassword;
